module.exports = __webpack_public_path__ + "static/img/共享运营平台4.8f16dac5.png";